import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { money } from "@/lib/api";
import { Wallet, Trophy, Home, LogOut, Shield, User, Gamepad2, Coins, MessageSquare } from "lucide-react";
import { useBranding } from "@/context/BrandingContext";

export function Navbar() {
  const { user, logout } = useAuth();
  const { branding } = useBranding();
  const navigate = useNavigate();
  const loc = useLocation();

  const links = [
    { to: "/lobby", label: "Lobby", icon: Gamepad2 },
    { to: "/carteira", label: "Carteira", icon: Wallet },
    { to: "/perfil", label: "Perfil", icon: User },
    { to: "/ranking", label: "Ranking", icon: Trophy },
    { to: "/forum", label: "Fórum", icon: MessageSquare },
  ];

  return (
    <header className="sticky top-0 z-40 glass border-b border-[#D4AF37]/15" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <Link to={user ? "/lobby" : "/"} className="flex items-center gap-2 shrink-0" data-testid="nav-logo">
          {branding?.logo_url ? (
            <img src={branding.logo_url} alt={branding.brand_name} className="h-9 w-auto object-contain" />
          ) : (
            <div className="w-9 h-9 rounded-lg btn-gold flex items-center justify-center font-head font-black text-lg">{(branding?.brand_name || "D")[0]}</div>
          )}
          <span className="font-head font-extrabold text-lg hidden sm:block">{branding?.brand_name || "DOMINÓ ROYALLE"}</span>
        </Link>

        {user && (
          <nav className="flex items-center gap-1 sm:gap-2 overflow-x-auto">
            {links.map((l) => {
              const Icon = l.icon;
              const active = loc.pathname === l.to;
              return (
                <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
                  className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${active ? "bg-[#D4AF37]/15 text-[#F3E5AB]" : "text-[#9CA3AF] hover:text-white"}`}>
                  <Icon size={16} /> <span className="hidden md:inline">{l.label}</span>
                </Link>
              );
            })}
            {user.is_admin && (
              <Link to="/admin" data-testid="nav-admin"
                className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${loc.pathname === "/admin" ? "bg-[#D4AF37]/15 text-[#F3E5AB]" : "text-[#9CA3AF] hover:text-white"}`}>
                <Shield size={16} /> <span className="hidden md:inline">Admin</span>
              </Link>
            )}
          </nav>
        )}

        <div className="flex items-center gap-3 shrink-0">
          {user ? (
            <>
              <Link to="/carteira" data-testid="nav-balance"
                className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#0F1319] border border-[#D4AF37]/25">
                <Wallet size={15} className="text-[#D4AF37]" />
                <span className="font-mono-num font-bold text-[#F3E5AB]">{money(user.credits)}</span>
              </Link>
              <Link to="/carteira" data-testid="nav-virtual-balance"
                className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#0F1319] border border-[#10B981]/25">
                <Coins size={15} className="text-[#10B981]" />
                <span className="font-mono-num font-bold text-[#10B981]">{Number(user.virtual_credits || 0).toLocaleString("pt-BR")}</span>
              </Link>
              <img src={user.picture || "https://api.dicebear.com/7.x/initials/svg?seed=" + user.name}
                alt="" className="w-9 h-9 rounded-full border-2 border-[#D4AF37]/40 object-cover" />
              <button onClick={() => { logout(); navigate("/"); }} data-testid="nav-logout"
                className="text-[#9CA3AF] hover:text-[#EF4444] transition-colors" title="Sair">
                <LogOut size={18} />
              </button>
            </>
          ) : null}
        </div>
      </div>
    </header>
  );
}
